<template>
  <div class='s-date-range-picker'>
      date range picker
  </div>
</template>

<script>
export default {
    name: 's-date-range-picker',
}
</script>

<style lang='scss'>

</style>